/* eslint-disable */
// /src/pages/FranchiseStoreCartPage.jsx

import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { useDriverStatusContext } from "../context/DriverStatusContext";
import {
    listFranchiseStoreCartItems,
    updateFranchiseStoreCartItemQty,
    deleteFranchiseStoreCartItem,
} from "../services/franchiseStoreCartService";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #F7FAFF;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;

const TopBar = styled.div`
  height: 52px;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid #e6eefc;
  button {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #111;
    padding: 6px 8px;
    border-radius: 10px;
    font-weight: 700;
    &:active {
      transform: translateY(1px);
    }
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 16px 20px;
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
`;

const InfoText = styled.div`
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Card = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 10px 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  gap: 8px;
`;

const CheckCol = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 6px;
  input {
    width: 16px;
    height: 16px;
  }
`;

const Thumb = styled.div`
  width: 86px;
  height: 86px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  span {
    font-size: 11px;
    color: #9ca3af;
  }
`;

const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.4;
`;

const OptionText = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
`;

const Price = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
`;

const QtyRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const QtyButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
`;

const QtyValue = styled.span`
  min-width: 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
`;

const CardBottomRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
`;

const OutlineButton = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  color: #4b5563;
`;

const EmptyBox = styled.div`
  margin-top: 40px;
  padding: 24px 14px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #ffffff;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.7;
`;

const SummaryBox = styled.div`
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #4b5563;
`;

const SummaryTotal = styled.div`
  font-size: 15px;
  font-weight: 800;
  color: #111827;
`;

const SummaryActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  justify-content: flex-end;
`;

const SummaryBtn = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 7px 11px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: #4b5563;
`;

const SummaryPrimaryBtn = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 0;
  background: #2563eb;
  padding: 7px 13px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
`;

const KRW = (n = 0) => (Number(n || 0)).toLocaleString("ko-KR") + "원";

const formatOptionText = (optionSelections) => {
    if (!Array.isArray(optionSelections) || !optionSelections.length) {
        return "선택된 옵션 없음";
    }
    return optionSelections
        .map((op) =>
            op.extraPrice
                ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})`
                : `${op.groupName}: ${op.value}`
        )
        .join(", ");
};

export default function FranchiseStoreCartPage() {
    const nav = useNavigate();
    const { phoneE164, loading: driverLoading } = useDriverStatusContext();

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busyId, setBusyId] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);

    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!phoneE164) {
                setLoading(false);
                setItems([]);
                return;
            }
            setLoading(true);
            try {
                const list = await listFranchiseStoreCartItems(phoneE164);
                if (cancelled) return;
                setItems(list);
            } catch (e) {
                console.error("[FranchiseStoreCartPage] list error", e);
                if (!cancelled) setItems([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        if (!driverLoading) {
            run();
        }

        return () => {
            cancelled = true;
        };
    }, [phoneE164, driverLoading]);

    const handleChangeQty = async (item, delta) => {
        if (!phoneE164) return;
        const current = Number(item.qty || 1);
        const next = current + delta;
        if (next <= 0) {
            const ok = window.confirm("해당 상품을 장바구니에서 삭제할까요?");
            if (!ok) return;
            try {
                setBusyId(item.id);
                setItems((prev) => prev.filter((it) => it.id !== item.id));
                setSelectedIds((prev) => prev.filter((id) => id !== item.id));
                await deleteFranchiseStoreCartItem(phoneE164, item.id);
            } catch (e) {
                console.error("[FranchiseStoreCartPage] delete error", e);
                alert("삭제 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
            } finally {
                setBusyId(null);
            }
            return;
        }

        try {
            setBusyId(item.id);
            setItems((prev) =>
                prev.map((it) =>
                    it.id === item.id ? { ...it, qty: next } : it
                )
            );
            await updateFranchiseStoreCartItemQty(phoneE164, item.id, next);
        } catch (e) {
            console.error("[FranchiseStoreCartPage] update qty error", e);
            alert("수량 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            setBusyId(null);
        }
    };

    const handleDelete = async (item) => {
        if (!phoneE164) return;
        const ok = window.confirm("해당 상품을 장바구니에서 삭제할까요?");
        if (!ok) return;
        try {
            setBusyId(item.id);
            setItems((prev) => prev.filter((it) => it.id !== item.id));
            setSelectedIds((prev) => prev.filter((id) => id !== item.id));
            await deleteFranchiseStoreCartItem(phoneE164, item.id);
        } catch (e) {
            console.error("[FranchiseStoreCartPage] delete error", e);
            alert("삭제 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            setBusyId(null);
        }
    };

    const handleGoDetail = (item) => {
        if (!item?.productId) return;
        nav(`/franchise-store/${item.productId}`);
    };

    const toggleSelect = (itemId) => {
        setSelectedIds((prev) =>
            prev.includes(itemId)
                ? prev.filter((id) => id !== itemId)
                : [...prev, itemId]
        );
    };

    const handleSelectAll = () => {
        if (!items.length) return;
        if (selectedIds.length === items.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(items.map((it) => it.id));
        }
    };

    const selectedItems = useMemo(
        () => items.filter((it) => selectedIds.includes(it.id)),
        [items, selectedIds]
    );

    // 선택된 상품 합계 (옵션 포함)
    const totalPrice = useMemo(() => {
        if (!selectedItems.length) return 0;
        return selectedItems.reduce((sum, item) => {
            const base = Number(item.unitPrice || 0);
            const optExtra = Array.isArray(item.optionSelections)
                ? item.optionSelections.reduce(
                    (s, op) => s + Number(op.extraPrice || 0),
                    0
                )
                : 0;
            const qty = Number(item.qty || 1);
            const unitTotal = base + optExtra;
            return sum + unitTotal * qty;
        }, 0);
    }, [selectedItems]);

    const handleDeleteSelected = async () => {
        if (!phoneE164) return;
        if (!selectedIds.length) {
            alert("삭제할 상품을 선택해 주세요.");
            return;
        }
        const ok = window.confirm("선택한 상품들을 장바구니에서 삭제할까요?");
        if (!ok) return;
        try {
            const toDelete = selectedIds.slice();
            setItems((prev) => prev.filter((it) => !toDelete.includes(it.id)));
            setSelectedIds([]);

            await Promise.all(
                toDelete.map((id) =>
                    deleteFranchiseStoreCartItem(phoneE164, id)
                )
            );
        } catch (e) {
            console.error("[FranchiseStoreCartPage] bulk delete error", e);
            alert("선택 삭제 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        }
    };

    // ✅ 선택 상품들을 /franchise-store/cart/checkout 으로 state로 넘김
    const handleOrderSelected = () => {
        if (!selectedItems.length) {
            alert("주문할 상품을 선택해 주세요.");
            return;
        }

        const checkoutItems = selectedItems.map((item) => ({
            cartItemId: item.id,
            productId: item.productId,
            productTitle:
                item.productTitleSnapshot || item.productTitle || "",
            thumb: item.thumb || "",
            unitPrice: item.unitPrice || 0,
            qty: item.qty || 1,
            optionSelections: item.optionSelections || [],
        }));

        nav("/franchise-store/cart/checkout", {
            state: {
                items: checkoutItems,
            },
        });
    };

    const renderItemCard = (item) => {
        const optText = formatOptionText(item.optionSelections);
        const base = Number(item.unitPrice || 0);
        const optExtra = Array.isArray(item.optionSelections)
            ? item.optionSelections.reduce(
                (s, op) => s + Number(op.extraPrice || 0),
                0
            )
            : 0;
        const unitTotal = base + optExtra;
        const subTotal = unitTotal * Number(item.qty || 1);
        const checked = selectedIds.includes(item.id);

        return (
            <Card key={item.id}>
                <CheckCol>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => toggleSelect(item.id)}
                    />
                </CheckCol>
                <Thumb>
                    {item.thumb ? (
                        <img src={item.thumb} alt="" />
                    ) : (
                        <span>이미지 없음</span>
                    )}
                </Thumb>
                <CardContent>
                    <Title>{item.productTitleSnapshot || "상품명 없음"}</Title>
                    <OptionText>{optText}</OptionText>
                    <PriceRow>
                        <Price>{KRW(subTotal)}</Price>
                        <QtyRow>
                            <QtyButton
                                type="button"
                                onClick={() => handleChangeQty(item, -1)}
                                disabled={busyId === item.id}
                            >
                                -
                            </QtyButton>
                            <QtyValue>{item.qty || 1}</QtyValue>
                            <QtyButton
                                type="button"
                                onClick={() => handleChangeQty(item, 1)}
                                disabled={busyId === item.id}
                            >
                                +
                            </QtyButton>
                        </QtyRow>
                    </PriceRow>
                    <CardBottomRow>
                        <OutlineButton
                            type="button"
                            onClick={() => handleGoDetail(item)}
                        >
                            상품 상세 보기
                        </OutlineButton>
                        <OutlineButton
                            type="button"
                            onClick={() => handleDelete(item)}
                            disabled={busyId === item.id}
                        >
                            삭제
                        </OutlineButton>
                    </CardBottomRow>
                </CardContent>
            </Card>
        );
    };

    return (
        <Wrap>
            <Sheet>
                <TopBar>
                    <button
                        onClick={() => nav("/franchise-store")}
                        aria-label="미터점 스토어로 이동"
                    >
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#111"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M3 11.5L12 4l9 7.5" />
                            <path d="M5 10.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9.5" />
                        </svg>
                        가맹점 스토어로 이동
                    </button>
                </TopBar>

                <Body>
                    <BrandHeader subtitle="가맹점 장바구니" />
                    <InfoText>
                        가맹점 스토어에서 담아둔 상품을 확인할 수 있습니다.
                        <br />
                        주문할 상품을 선택한 뒤 주문을 진행해 주세요.
                    </InfoText>

                    {driverLoading ? (
                        <div>불러오는 중…</div>
                    ) : !phoneE164 ? (
                        <EmptyBox>
                            로그인 정보를 찾을 수 없습니다.
                            <br />
                            홈 화면에서 다시 접속해 주세요.
                        </EmptyBox>
                    ) : loading ? (
                        <div>불러오는 중…</div>
                    ) : !items.length ? (
                        <EmptyBox>장바구니에 담긴 상품이 없습니다.</EmptyBox>
                    ) : (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    fontSize: 12,
                                    color: "#6b7280",
                                }}
                            >
                                <label
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        cursor: "pointer",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={
                                            items.length > 0 &&
                                            selectedIds.length === items.length
                                        }
                                        onChange={handleSelectAll}
                                    />
                                    <span>전체 선택</span>
                                </label>
                                <span>
                                    선택 {selectedIds.length}개 / 총 {items.length}개
                                </span>
                            </div>

                            <List>{items.map(renderItemCard)}</List>

                            <SummaryBox>
                                <SummaryRow>
                                    <span>선택 상품 합계 (옵션 포함)</span>
                                    <SummaryTotal>{KRW(totalPrice)}</SummaryTotal>
                                </SummaryRow>
                            </SummaryBox>

                            <SummaryActions>
                                <SummaryBtn type="button" onClick={handleDeleteSelected}>
                                    선택 삭제
                                </SummaryBtn>
                                <SummaryPrimaryBtn
                                    type="button"
                                    onClick={handleOrderSelected}
                                >
                                    선택 상품 주문하기
                                </SummaryPrimaryBtn>
                            </SummaryActions>
                        </>
                    )}
                </Body>
            </Sheet>
        </Wrap>
    );
}
